import PropTypes from "prop-types";
import React from "react";
import RadioType from "../display-types/radio";
import TextType from "../display-types/text";
import NumberWithUnit from "../display-types/number-with-unit";
import CheckboxType from "../display-types/checkbox";
import HourMinuteType from "../display-types/hour-minute";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const HorizontalGroupingLayout = ({ subsection, selectedLanguage }) =>
  <section>
    <h2>
      <FormattedMessage
        id={subsection.subsectionName}
        defaultMessage={subsection.subsectionName}
      />
    </h2>

    {subsection.subsectionTag === "physical_activity_text_input" &&
      <strong>
        <FormattedMessage {...messages.subsectionTagTextDescription} />
      </strong>}

    <div className="cxa-grid__wrapper apl-questionnaire__grouped">
      {subsection.questions.map(q => {
        switch (q.displayType) {
          case "radio":
            return (
              <div key={q.tag} className="cxa-grid__item cxa-grid__item--three">
                <RadioType question={q} selectedLanguage={selectedLanguage} />
              </div>
            );
          case "hour_minute":
            return (
              <div key={q.tag} className="cxa-grid__item cxa-grid__item--three">
                <HourMinuteType question={q} />
              </div>
            );
          case "text":
            if (q.units) {
              return (
                <div
                  key={q.tag}
                  className="cxa-grid__item cxa-grid__item--three"
                >
                  <NumberWithUnit question={q} />
                </div>
              );
            }
            return (
              <div key={q.tag} className="cxa-grid__item cxa-grid__item--three">
                <TextType question={q} />
              </div>
            );
          case "checkbox":
            return <CheckboxType key={q.tag} question={q} />;
          default:
            return "";
        }
      })}
    </div>
  </section>;

HorizontalGroupingLayout.propTypes = {
  subsection: PropTypes.object,
  selectedLanguage: PropTypes.object,
};

export default HorizontalGroupingLayout;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/layouts/horizontal-grouping.jsx